const isNumeric = (value: string) => {
    return /^-?\d+$/.test(value);
};

const isValidHourPart = (value?: string): boolean => {
    if (!value || !isNumeric(value)) {
        return false;
    }

    const valueAsInt = +value;
    return valueAsInt >= 0 && valueAsInt <= 23;
};

const isValidMinutePart = (value?: string): boolean => {
    if (!value || !isNumeric(value)) {
        return false;
    }

    const valueAsInt = +value;
    return valueAsInt >= 0 && valueAsInt <= 59;
};

export const isValidExpextedRaceTime = (value?: string): boolean => {
    if (!value) {
        return true;
    }

    const parts = value.split(":");

    if (parts.length !== 2) {
        return false;
    }

    return isValidHourPart(parts[0]) && isValidMinutePart(parts[1]);
};
